<template>
	<section class="firstLogin">
		<div class="login-cntr d-flex align-items-center justify-center flex-wrap">
			<div class="m-auto login-box d-flex align-items-center flex-wrap">
				<div class="align-items-center d-flex flex-wrap">
					<div class="m-0 row justify-content-center">
						<div class="container">
							<h1 class="text-center">{{ $t('lang.content.new_password') }}</h1>
							<p class="text-center">
								{{ $t('lang.content.change_firstPassword') }}
							</p>
						</div>
						<div>
							<form @submit.prevent="onSubmit" novalidate>
								<b-form-invalid-feedback v-if="msjErrorlogin.length != 0">{{
									msjErrorlogin
								}}</b-form-invalid-feedback>

								<div
									class="form-group"
									:class="{ 'form-group--error': oldPasswordError.show }"
								>
									<label>{{ $t('lang.content.oldPassword') }}</label>
									<input
										type="password"
										class="form-control form-control__password"
										v-model.lazy="oldPassword"
										:placeholder="$t('lang.content.enter_Password')"
									/>
									<div v-if="oldPasswordError.show" class="invalid-feedback">
										<div
											class="error"
											v-if="oldPasswordError.type == 'wrong'"
										>
											{{ $t('lang.content.password_wrong') }}
										</div>
										<div
											class="error"
											v-if="oldPasswordError.type == 'required'"
										>
											{{ $t('lang.content.password_required') }}
										</div>
									</div>
								</div>

								<div
									class="form-group"
									:class="{ 'form-group--error': passwordError.show }"
								>
									<label>{{ $t('lang.content.new_password') }}</label>
									<input
										type="password"
										class="form-control form-control__password"
										v-model.lazy="password"
										:placeholder="$t('lang.content.type_newPassword')"
									/>
									<div v-if="passwordError.show" class="invalid-feedback">
										<div
											class="error"
											v-if="passwordError.type == 'required'"
										>
											{{ $t('lang.content.password_required') }}
										</div>
										<div
											class="error"
											v-if="passwordError.type == 'wrong'"
										>
											{{ $t('lang.content.password_required') }}
										</div>
									</div>
								</div>

								<div
									class="form-group"
									:class="{ 'form-group--error': confirmPasswordError.show }"
								>
									<label>{{ $t('lang.content.repeat_password') }}</label>
									<input
										type="password"
										class="form-control form-control__password"
										v-model.lazy="confirmPassword"
										:placeholder="$t('lang.content.repeat_password')"
									/>
									<div
										v-if="confirmPasswordError.show"
										class="invalid-feedback"
									>
										<div
											class="error"
											v-if="confirmPasswordError.type == 'required'"
										>
											{{ $t('lang.content.password_required') }}
										</div>
										<div
											class="error"
											v-if="confirmPasswordError.type == 'wrong'"
										>
											{{ $t('lang.content.long_password') }}
										</div>
									</div>
								</div>

								<div
									class="
										d-flex
										flex-wrap
										justify-content-lg-end
										align-items-center
										btn-wrap
										pt-md-4 pt-2
									"
								>
									<button class="btn btn-outline-info" type="submit">
										{{ $t('lang.buttons.send') }}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import userService from '../../../services/UsersService';
import sesionService from '../../../services/SesionService';

export default {
	name: 'firstLogin',
	components: {},
	props: [],
	data() {
		return {
			errors: [],
			show: false,
			usuario: '',
			email: '',
			user: {},
			password: '',
			confirmPassword: '',
			oldPassword: '',
			submitted: false,
			msjErrorlogin: '',
			oldPasswordError: {
				show: false,
				type: ''
			},
			passwordError: {
				show: false,
				type: ''
			},
			confirmPasswordError: {
				show: false,
				type: ''
			},
			$v: {}
		};
	},
	validation: {},
	watch: {
		oldPassword() {
			this.msjErrorlogin = '';
			userService.postCheckPassword(this.oldPassword).then(({ correctPassword }) => {
				this.oldPasswordError.show = !correctPassword;
				this.oldPasswordError.type = 'wrong';
			});
		},
		password() {
			this.msjErrorlogin = '';

			this.passwordError.show = false;
			this.passwordError.type = '';
		},
		confirmPassword() {
			this.msjErrorlogin = '';

			this.confirmPasswordError.show = false;
			this.confirmPasswordError.type = '';
		}
	},
	created() {
		this.user = sesionService.getUser().Data;
	},
	methods: {
		async onSubmit() {
			this.submitted = true;
			let callMethod = true;
			if (!this.oldPassword) {
				this.oldPasswordError.show = true;
				this.oldPasswordError.type = 'required';
				callMethod = false;
			}

			if (!this.password) {
				this.passwordError.show = true;
				this.passwordError.type = 'required';
				callMethod = false;
			} else if (this.password.length < 7) {
				this.passwordError.show = true;
				this.passwordError.type = 'wrong';
				callMethod = false;
			}

			if (!this.confirmPassword) {
				this.confirmPasswordError.show = true;
				this.confirmPasswordError.type = 'required';
				callMethod = false;
			} else if (this.confirmPassword.length < 7) {
				this.confirmPasswordError.show = true;
				this.confirmPasswordError.type = 'wrong';
				callMethod = false;
			}

			if (callMethod) {
				try {
					let res = await userService.postUpdateFirstPassword(
						this.user.perfil.email,
						this.password
					);
					if (res.Code == 200) sesionService.redirectHome();
				} catch (error) {
					if (error.isAxiosError) {
						const status = error.response.status;
						// console.log(error.response.data);
						if (status != 200) {
							const responseMessage = error.response.data.Data
								? error.response.data.Data[0].msg
								: error.response.data.Message;
							this.msjErrorlogin = responseMessage;
						}
					} else {
						console.log('UnexpectedError:', error);
					}
				}
			}
		},
		fadeMe: function () {
			this.show = !this.show;
		}
	}
};
</script>
